import React, { useState, useEffect, useCallback } from "react";
import { API } from "../../API";
import { Button, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { notify } from "react-notify-toast"
import debounce from 'lodash.debounce';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from "moment";
import dayjs from 'dayjs';
import SearchBar from "../../Components/SearchBar/SearchBar";
import FilterAccordion from "../../Components/SearchTeacherFilter/CollapseFilter";
import LocationFilter from "../../Components/SearchTeacherFilter/LocationFilter";
const _ = require('lodash')

const CollegeJobListSearchBar = (props) => {

	const {
		onSearchBooking
	} = props

	const [qualificationList, setQualificationList] = useState([])
	const [levels, setVETLevel] = useState([])

	const [searchFilter, setSearchFilter] = useState({
		teacher_name: null,
		class_level_ids: [],
		class_level_names: [],
		locations: [],
		date_range: null,
		search_date: null
	})
	const [vetQualificationSearch, setVETQualificationSearch] = useState({})
	const [searchName, setSearchName] = useState('')

	useEffect(() => {
		const strSearch = window.localStorage.getItem('searchBookingByCollegeFilter')
		if (strSearch) {
			const currentFilter = JSON.parse(strSearch)
			setSearchFilter(currentFilter)
			setVETQualificationSearch(currentFilter?.vetQualificationSearch || {})
			setSearchName(currentFilter.teacher_name)
		}
		else {
			setSearchFilter({
				teacher_name: null,
				class_level_ids: [],
				class_level_names: [],
				locations: [],
				date_range: null,
				search_date: null
			})
		}
		API.getQualificationList().then(result => {
			const qualifications = result?.data?.data
			// get all level of VET
			let levels = []
			let levelPriorities = []
			qualifications.filter(item => item.type === 'vet').forEach((item => {
				const subQualifications = item.qualifications
				subQualifications.forEach(ele => {
					if (!levels.includes(ele.level) && ele.level?.length) {
						levels.push(ele.level)
						levelPriorities.push({
							name: ele.level,
							priority: ele.priority
						})
					}
					else if (levels.includes(ele.level) && ele.level?.length && ele.priority) {
						const itemIndex = levelPriorities.findIndex(item => item.name === ele.level)
						levelPriorities = [
							...levelPriorities.slice(0, itemIndex),
							{
								name: ele.level,
								priority: ele.priority
							},
							...levelPriorities.slice(itemIndex + 1)
						]
					}
				})
			}))

			levels.sort((a, b) => {
				const priorityA = levelPriorities.find(item => item.name === a)?.priority || 0;
				const priorityB = levelPriorities.find(item => item.name === b)?.priority || 0;
				return priorityA - priorityB;
			})
			setQualificationList(qualifications)
			setVETLevel(levels)
		})
	}, [])


	const debouncedOnChange = useCallback(debounce((key, value, checked, qua = null, vetQualificationSearchData, searchFilterData) => {
		let searchData = { ...searchFilterData }
		if (key === 'location') {
			let locations = searchFilterData.locations
			if (value === 'online_only') {
				if(checked) {
					locations = [value]
				}
				else {
					locations = []
				}
			}
			else {
				if (checked && !locations.includes(value)) {
					locations.push(value)
				}
				else if (!checked) {
					locations = locations.filter(ele => ele !== value)
				}
				locations = locations.filter(ele => ele !== 'online_only')
			}
			searchData = {
				...searchFilterData,
				locations
			}
		}
		else if (key === 'class_level_ids') {
			const splitValue = value.split("_id:")?.[0]
			const splitID = value.split("_id:")?.[1]
			// console.log("can_deliver value: ", splitValue, splitID, qua?.title)
			const keyType = qua ? qua._id : 'other'
			const quaTitle = qua ? qua.title : ""
			let newValidUnitValue = vetQualificationSearchData[keyType] || []
			let newVETQualificationSearch = { ...vetQualificationSearchData }
			let validArr = _.flatten(Object.values(vetQualificationSearchData))
			if (checked) {
				if (quaTitle !== splitValue) {
					newValidUnitValue = vetQualificationSearchData[keyType]?.length ?
						[...vetQualificationSearchData[keyType], value] :
						[value]
					newVETQualificationSearch = {
						...vetQualificationSearchData,
						[keyType]: newValidUnitValue.filter(eleValue => eleValue.split("_id:")?.[0] !== quaTitle)
					}
					setVETQualificationSearch(newVETQualificationSearch)
					validArr = _.flatten(Object.values(newVETQualificationSearch))
				}
				else {
					newVETQualificationSearch = {
						...vetQualificationSearchData,
						[keyType]: [value]
					}
					setVETQualificationSearch(newVETQualificationSearch)
					validArr = _.flatten(Object.values(newVETQualificationSearch))
				}

				searchData = {
					...searchFilterData,
					class_level_ids: [
						...searchFilterData.class_level_ids,
						splitID
					].filter(ele => validArr.map(item => item.split("_id:")?.[1]).includes(ele)),
					class_level_names: [
						...searchFilterData.class_level_names,
						value
					].filter(ele => validArr.includes(ele))
				}

			} else {
				searchData = {
					...searchFilterData,
					class_level_ids: [
						...searchFilterData.class_level_ids.filter(item => item !== splitID),
					],
					class_level_names: [
						...searchFilterData.class_level_names.filter(item => item !== splitValue && item !== value),
					]
				}
				newVETQualificationSearch = {
					...vetQualificationSearchData,
					[keyType]: vetQualificationSearchData[keyType].filter(ele => ele !== value)
				}
				setVETQualificationSearch(newVETQualificationSearch)
			}
		}
		else if (key === 'search_date') {
			searchData = {
				...searchFilterData,
				[key]: value,
				date_range: null
			}
		}
		else if (key === 'teacher_name') {
			searchData = {
				...searchFilterData,
				[key]: value
			}
		}
		else {
			if (checked) {
				searchData = {
					...searchFilterData,
					[key]: value,
					search_date: key === 'date_range' ? null : searchData?.search_date
				}
			}
			else {
				searchData = {
					...searchFilterData,
					[key]: null
				}
			}
		}
		setSearchFilter(searchData)
		onSearchBooking(searchData)
	}, 600), []);

	const onChange = (key, e, qua = null) => {
		if(key === 'search_date') {
			debouncedOnChange(key, e, true, qua, vetQualificationSearch, searchFilter);
		}
		else if(key === 'teacher_name') {
			setSearchName(e.target.value)
			debouncedOnChange(key, e.target.value, e.target.checked, qua, vetQualificationSearch, searchFilter);
		}
    	else {
			debouncedOnChange(key, e.target.value, e.target.checked, qua, vetQualificationSearch, searchFilter);
		}
  };

	const saveFilter = () => {
		window.localStorage.setItem('searchBookingByCollegeFilter', JSON.stringify({ ...searchFilter, vetQualificationSearch }))
		notify.show('Saved filter successfully')
	}

	const removeFilter = () => {
		window.localStorage.removeItem('searchBookingByCollegeFilter')
		notify.show('Removed filter successfully')
		setSearchName('')
		const searchData = {
			teacher_name: null,
			class_level_ids: [],
			class_level_names: [],
			locations: [],
			date_range: null,
			search_date: null
		}
		setSearchFilter(searchData)
		setVETQualificationSearch({})
		// searchBooking(searchData)
		onSearchBooking(searchData)
	}

	return (
		searchFilter && <div className="search-teacher-filters">
			<h2 className="search-teacher-subheading">
				{props.user.is_childcare_centre ? "Search by Educator Name" : "Search by Teacher Name"}
			</h2>
			<div className="w-100 d-flex justify-content-center">
				<SearchBar
					placeholder="Type name"
					onChange={(e) => onChange('teacher_name', e)}
					altColours
					value={searchName}
				/>
			</div>


			<hr className="my-4" />
			<h2 className="search-teacher-subheading">
				Filter by Course Type/ Specialisation
			</h2>


			{qualificationList?.length && levels?.length && <FilterAccordion
				qualificationList={qualificationList}
				levels={levels}
				selectedList={searchFilter.class_level_names || []}
				vetQualificationSearch={vetQualificationSearch}
				onChangeCategory={(e, qua) => onChange('class_level_ids', e, qua)}
				showTwoColumns={false}
			/>}

			<hr className="my-4" />
			<div className="">
				<h2 className="search-teacher-subheading-no-margin mb-3">Search by Location</h2>
				<div className="w-100 d-flex justify-content-center flex-column">
					<LocationFilter onChange={(key, e) => onChange(key, e)} searchFilter={searchFilter} />
				</div>
			</div>

			<hr className="my-4" />
			<div className="">
				<h2 className="search-teacher-subheading-no-margin">Date</h2>
				<FormControlLabel
					control={<Checkbox id={'in-progress'} value={'in-progress'} checked={searchFilter?.['date_range'] === 'in-progress'} />}
					label={'In-progress'}
					onChange={(e) => onChange('date_range', e)}
				/>
				<FormControlLabel
					control={<Checkbox id={'completed'} value={'completed'} checked={searchFilter?.['date_range'] === 'completed'} />}
					label={'Completed'}
					onChange={(e) => onChange('date_range', e)}
				/>
				<FormControlLabel
					control={<Checkbox id={'future'} value={'future'} checked={searchFilter?.['date_range'] === 'future'} />}
					label={'Future'}
					onChange={(e) => onChange('date_range', e)}
				/>
				<p className="text-center my-2">or choose a specific date</p>
				<div className="w-100 d-flex justify-content-center">
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<StaticDatePicker
							openTo="day"
							// views={['day', 'month', 'year']}
							componentsProps={{ actionBar: { actions: ['clear'] } }}
							value={searchFilter.search_date ? dayjs(moment(searchFilter.search_date, "DD-MM-YYYY").format("MM-DD-YYYY")) : null}
							onChange={(date) => onChange("search_date", date ? moment(date["$d"]).format("DD-MM-YYYY") : null)}
							onAccept={(date) => onChange("search_date", date ? moment(date["$d"]).format("DD-MM-YYYY") : null)}
							onClose={(date) => onChange("search_date", null)}
						/>
					</LocalizationProvider>
				</div>
			</div>

			{/* <hr className="my-4" /> */}
			{/* <div className="">
			<h2 className="search-teacher-subheading-no-margin">Modality</h2>
			<FormControlLabel
				control={<Checkbox id={'online_only'} value={'online_only'} checked={searchFilter?.['modality'] === 'online_only'} />}
				label={'Can teach online'}
				onChange={(e) => onChange('modality', e)}
			/>
			<FormControlLabel
				control={<Checkbox id={'hybrid'} value={'hybrid'} checked={searchFilter?.['modality'] === 'hybrid'} />}
				label={'Can teach hybrid online/F2F'}
				onChange={(e) => onChange('modality', e)}
			/>
		</div> */}
			<div className="my-4 text-center d-flex flex-row">
				<Button className="mx-2" variant="outlined" onClick={() => saveFilter()}>Save these filters on this device</Button>
				<Button className="mx-2" variant="outlined" onClick={() => removeFilter()}>Clear saved filters</Button>
			</div>
		</div>
	)
}

export default CollegeJobListSearchBar